"use client";

import { useContext, useEffect } from "react";
import Featured from "../Featured";
import EventsList from "./EventsList";
import Introduction from "@/components/Introduction";
import { LanguageContext } from "@/context/languageContext";
import { FeaturedComponent } from "@/types/modules";
import { EventsOptions } from "@/types/wordpress";
import { Event } from "@/types/wordpress";
import { useLanguageUrl } from "@/context/languageURLContext";

interface EventsComponentProps {
  eventsData: Event[];
  eventsOptions: EventsOptions;
}

export default function EventsComponent({
  eventsData,
  eventsOptions,
}: EventsComponentProps) {
  const { language } = useContext(LanguageContext);

  const { url, setUrl } = useLanguageUrl(); // Access context values

  useEffect(() => {
    setUrl(`/${language === "en" ? "de" : "en"}/events`);
  }, [language, setUrl]);

  const featured: FeaturedComponent = {
    backgroundColor:
      language === "en"
        ? eventsOptions.eventsOptions.featured.backgroundColor
        : eventsOptions.eventsOptionsDE.featured.backgroundColor,
    title:
      language === "en"
        ? eventsOptions.eventsOptions.featured.title
        : eventsOptions.eventsOptionsDE.featured.title,
    custom:
      language === "en"
        ? eventsOptions.eventsOptions.featured.custom
        : eventsOptions.eventsOptionsDE.featured.custom,
  };

  return (
    <>
      <Introduction
        title={
          language === "en"
            ? eventsOptions.eventsOptions.introduction.title
            : eventsOptions.eventsOptionsDE.introduction.title
        }
        content={
          language === "en"
            ? eventsOptions.eventsOptions.introduction.content
            : eventsOptions.eventsOptionsDE.introduction.content
        }
      />
      <EventsList events={eventsData} />
      <Featured featured={featured} />
    </>
  );
}
